import { pollArchivedQaJob } from './qaWorkbookRequests';

export async function requestLargeQaSave(document, scratchPad, clientSubNumber, status, xlType, options,
  { authenticate, invoke, requestId }) {
  const user = await authenticate();
  const token = user.signInUserSession.idToken.jwtToken;
  if (document?.archivedQa) {
    const job = await pollArchivedQaJob(invoke, { access_token: token, target: 'prepare-archived-qa-save',
      archivedQa: document.archivedQa, document_id: document.document_id, requestId: requestId(),
      scratchPad, clientSubNumber, status, sourceJsonPath: options.sourceJsonPath || document.jsonExtractpath,
      removeTransformedSheets: options.removeTransformedSheets, consolidatedSheetName: options.consolidatedSheetName,
      summarySheetName: options.summarySheetName, documentFileName: options.documentFileName,
      reviewJobId: options.reviewJobId, preserveReviewNotes: options.preserveReviewNotes === true, notifyCount: options.notifyCount,
      ...(options.prepareForSend === true ? { prepareForSend: true } : {}),
      sendOnComplete: options.sendOnComplete === true, selectMode: options.selectMode }, { onProgress: options.onProgress });
    return { success: true, ...job.outputs, document: job.document, delivery: job.delivery };
  }
  const result = await invoke('instanceHandler', { body: { access_token: token, target: 'save-large-qa-file',
    document, scratchPad, clientSubNumber, status, inputFileType: xlType, userEmail: user.attributes.email,
    notifyCount: options.notifyCount, removeTransformedSheets: options.removeTransformedSheets,
    consolidatedSheetName: options.consolidatedSheetName, summarySheetName: options.summarySheetName,
    documentFileName: options.documentFileName, sourceJsonPath: options.sourceJsonPath || document?.jsonExtractpath,
    requireTransformedWorkbook: options.requireTransformedWorkbook === true } });
  return result?.response;
}

export async function requestLargeQaSend(document, scratchPad, clientSubNumber, status, xlType, options, bridges) {
  if (document?.archivedQa) {
    const saved = document.processingStatus === 'QA Complete' ? { success: true, document }
      : await requestLargeQaSave(document, scratchPad, clientSubNumber, status, xlType, { ...options, prepareForSend: true, sendOnComplete: false }, bridges);
    if (!saved.document?.archivedQa || saved.document.document_id !== document.document_id) throw new Error('The archived QA save did not confirm its document.');
    options.onSaved?.(saved.document);
    const user = await bridges.authenticate();
    const current = saved.document;
    const result = await bridges.invoke('instanceHandler', { body: { target: 'notifyclient',
      access_token: user.signInUserSession.idToken.jwtToken, archivedQa: current.archivedQa,
      asyncResponse: options.asyncResponse === true, diagnosticReference: options.diagnosticReference,
      data: { submissionid: current.submissionIdentifier, documentname: current.documentName,
        submission_number: clientSubNumber, templateName: current.templateName,
        originalMsgFileName: current.documentName, originalInputFileName: current.documentName,
        document_id: current.document_id, status: options.sendStatus || (current.processingStatus === 'QA Complete' ? 'QA Complete' : status), selectMode: options.selectMode } } });
    return { success: true, saved, sendResult: result?.response ?? result };
  }
  const user = await bridges.authenticate();
  const result = await bridges.invoke('instanceHandler', { body: {
    access_token: user.signInUserSession.idToken.jwtToken, target: 'send-large-qa-file', document,
    scratchPad, clientSubNumber, status, inputFileType: xlType, userEmail: user.attributes.email,
    selectMode: options.selectMode, sendStatus: options.sendStatus, asyncResponse: options.asyncResponse === true,
    removeTransformedSheets: options.removeTransformedSheets, consolidatedSheetName: options.consolidatedSheetName,
    summarySheetName: options.summarySheetName, documentFileName: options.documentFileName,
    sourceJsonPath: options.sourceJsonPath || document?.jsonExtractpath,
    requireTransformedWorkbook: options.requireTransformedWorkbook !== false, diagnosticReference: options.diagnosticReference } });
  return result?.response;
}
